module.exports = __webpack_public_path__ + "img/rainbowchurchlogo.ec117ec5.png";